import { useEffect, useState } from "react";
import { checkMandatoryFields, FORM_KEYS } from "./helper";
import HospitalizationDetails from "./HospitalizationDetails";
import OtherExistingPolicyDetails from "./OtherExistingPolicyDetails";
import ClaimIntimatedDetails from "./ClaimIntimatedDetails";
import PatientDetails from "./PatientDetails";
import Documents from "./Documents";
import MultiStep from "../../../../utilsComponent/MultiStep";
import "./claimForm.scss"
import ReviewPage from "./Review/ReviewPage";
import SuccessModal from "../../../../utilsComponent/SuccessModal";
import LeavePageConfirmationModal from "../../../../utilsComponent/LeavePageConfirmationModal";
import { fetchAilmentTypes, fetchCoverageTypes, fetchDocumentTypes, fetchHospitalizationReasons, fetchRelations, generateClaim } from "./apiHelper";
import { fetchStates } from "../../../apiHelper";

const ClaimForm = ({ setShowClaimForm, policyData, setLoading }) => {

    const defaultHospitalizationDetails = {
        [FORM_KEYS.date_of_admission]: null,
        [FORM_KEYS.time_of_admission]: null,
        [FORM_KEYS.date_of_discharge]: null,
        [FORM_KEYS.time_of_discharge]: null,
        [FORM_KEYS.pincode]: "",
        [FORM_KEYS.state]: null,
        [FORM_KEYS.district]: null,
        [FORM_KEYS.mandal]: null,
        [FORM_KEYS.village]: null,
        [FORM_KEYS.hospital]: null,
        [FORM_KEYS.hospital_name]: "",
        [FORM_KEYS.hospital_city_and_pincode]: null,
        [FORM_KEYS.icu_days]: "",
        [FORM_KEYS.non_icu_days]: "",
        [FORM_KEYS.doctor_name]: "",
        [FORM_KEYS.doctor_mobile_number]: "",
        [FORM_KEYS.doctor_registration_number]: "",
        [FORM_KEYS.reason_of_hospitalization]: "",
        [FORM_KEYS.ailment]: null,
        [FORM_KEYS.description_of_diagnosis]: ""
    }

    const defaultExistingPolicyDetails = {
        [FORM_KEYS.policy_number]: "",
        [FORM_KEYS.insurer_name]: "",
        [FORM_KEYS.sum_insured]: "",
        [FORM_KEYS.coverage_type]: "",
        [FORM_KEYS.policy_start_date]: "",
        [FORM_KEYS.policy_end_date]: ""
    }

    const defaultValues = {
        [FORM_KEYS.intimated_by]: "",
        [FORM_KEYS.intimator_name]: "",
        [FORM_KEYS.relationship]: "",
        [FORM_KEYS.intimator_mobile_number]: "",
        [FORM_KEYS.patient]: null,
        [FORM_KEYS.alternate_mobile_number]: "",
        [FORM_KEYS.date_of_incidence]: null,
        [FORM_KEYS.time_of_incidence]: null,
        hospitalizationDetails: [
            defaultHospitalizationDetails
        ],
        [FORM_KEYS.have_other_policies]: "No",
        existingPolicyDetails: [],
        attachment_type: null,
        document_ids: [
            {
                documentType: null,
                docs: []
            }
        ],
    }

    const [formData, setFormData] = useState(defaultValues);
    const [currentStep, setCurrentStep] = useState(1);
    const [disableNextButton, setDisableNextButton] = useState(false);
    const [showExitModal, setShowExitModal] = useState(false);
    const [showClaimSuccessModal, setShowClaimSuccessModal] = useState(false);
    const [claimID, setClaimID] = useState(false);
    const [relationshipList, setRelationshipList] = useState([]);
    const [hospitalizationReasons, setHospitalizationReasons] = useState([]);
    const [ailmentList, setAilmentList] = useState([]);
    const [statesList, setStatesList] = useState([]);
    const [coverageTypes, setCoverageTypes] = useState([]);
    const [documentTypes, setDocumentTypes] = useState([]);

    const setValue = (key, value) => {
        setFormData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const setHospitalizationDetails = (hospitalIndex, key, value) => {
        setFormData((prev) => ({
            ...prev,
            hospitalizationDetails: prev.hospitalizationDetails?.map((item, index) =>
                index === hospitalIndex ? { ...item, [key]: value } : item
            ),
        }));
    };

    const setExistingPolicyDetails = (policyIndex, key, value) => {
        setFormData((prev) => ({
            ...prev,
            existingPolicyDetails: prev.existingPolicyDetails?.map((item, index) =>
                index === policyIndex ? { ...item, [key]: value } : item
            ),
        }));
    }

    const getRelations = async () => {
        setLoading(true)
        const response = await fetchRelations();
        setLoading(false)
        setRelationshipList(response)
    }
    const getHospitalizationReason = async () => {
        setLoading(true)
        const response = await fetchHospitalizationReasons();
        setLoading(false)
        setHospitalizationReasons(response)
    }
    const getAilmentTypes = async () => {
        setLoading(true)
        const response = await fetchAilmentTypes();
        setLoading(false)
        setAilmentList(response)
    }

    const getStatesList = async () => {
        setLoading(true);
        const fetchedStates = await fetchStates();
        setLoading(false)
        setStatesList(fetchedStates);
    };

    const getCoverageTypes = async () => {
        setLoading(true)
        const response = await fetchCoverageTypes();
        setCoverageTypes(response)
        setLoading(false)
    }

    const getDocumentTypes = async () => {
        setLoading(true)
        const response = await fetchDocumentTypes();
        setDocumentTypes(response)
        setLoading(false)
    }

    const customStyles = {
        control: (base, state) => ({
            ...base,
            border: 'none',
            boxShadow: 'none',
            fontWeight: '500',
            borderBottom: '1px solid #D2D2E4',
            borderRadius: 0,
            width: '95%',
            '&:hover': {
                borderBottom: '1px solid #D2D2E4',
            },
            '& .ms-3__indicator-separator': {
                display: 'none',
            },
            '& .css-1u9des2-indicatorSeparator': {
                display: 'none',
            },
        }),
    };

    const steps = [
        "Claim Intimated Details",
        "Patient Details",
        "Hospitalization Details",
        "Other Existing Health Policy Details",
        "Documents Upload",
        "Review & Submit"
    ];

    const handleNext = () => {
        if (currentStep < steps.length) setCurrentStep(currentStep + 1);
        else if (currentStep === steps.length) {
            // Call the API to submit the claim
            generateClaim(formData, policyData, setShowClaimSuccessModal, setClaimID, setLoading)
        }
    };

    const handleBack = () => {
        if (currentStep > 1) setCurrentStep(currentStep - 1);
        else {
            setShowExitModal(true)
        };
    };
    const renderStepComponent = () => {
        switch (currentStep) {
            case 1:
                return <ClaimIntimatedDetails formData={formData} setValue={setValue} customStyles={customStyles} relationshipList={relationshipList} />;
            case 2:
                return <PatientDetails formData={formData} setValue={setValue} customStyles={customStyles} policyData={policyData} setLoading={setLoading} />;
            case 3:
                return (
                    <HospitalizationDetails
                        customStyles={customStyles}
                        formData={formData}
                        setValue={setValue}
                        setHospitalizationDetails={setHospitalizationDetails}
                        setFormData={setFormData}
                        defaultHospitalizationDetails={defaultHospitalizationDetails}
                        hospitalizationReasons={hospitalizationReasons}
                        ailmentList={ailmentList}
                        statesList={statesList}
                    />
                );
            case 4:
                return (
                    <OtherExistingPolicyDetails
                        customStyles={customStyles}
                        formData={formData}
                        setFormData={setFormData}
                        setValue={setValue}
                        defaultExistingPolicyDetails={defaultExistingPolicyDetails}
                        setExistingPolicyDetails={setExistingPolicyDetails}
                        coverageTypes={coverageTypes}
                    />
                );
            case 5:
                return <Documents formData={formData} setValue={setValue} customStyles={customStyles} policyData={policyData} setLoading={setLoading} documentTypes={documentTypes} />;
            case 6:
                return <ReviewPage formData={formData} />;
            default:
                return null;
        }
    };

    useEffect(() => {
        setDisableNextButton(checkMandatoryFields(formData, currentStep))
    }, [currentStep, formData])

    useEffect(() => {
        getRelations();
        getHospitalizationReason();
        getAilmentTypes();
        getStatesList();
        getCoverageTypes();
        getDocumentTypes();
    }, [])

    return (
        <section className="p-4 pb-0 pt-1">
            <div>
                <div className="outer-boxPolicy claim-form p-1">
                    <MultiStep
                        steps={steps}
                        currentStep={currentStep}
                        onNext={handleNext}
                        onBack={handleBack}
                        disableNextButton={disableNextButton}
                    >
                        <div className="inner-boxPolicy p-2 mb-2 w-100">
                            {renderStepComponent()}
                        </div>
                    </MultiStep>
                </div>
            </div>
            {showExitModal && (
                <LeavePageConfirmationModal
                    closeModal={() => { setShowExitModal(false) }}
                    confirmPageLeave={() => {
                        setShowClaimForm(false)
                        setShowExitModal(false)
                    }}
                />
            )}
            {showClaimSuccessModal && (
                <SuccessModal claimID={claimID} modalShow={showClaimSuccessModal} handleOkClick={() => { setShowClaimForm(false) }} />
            )}
        </section>
    )
}
export default ClaimForm;